import styled from "styled-components";

export const CreateProjectsSc = styled.div`
  width: 100vw;
  position: absolute;
  top: 55px;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  .form-container {
    width: 50%;
    background-color: #f5f5f5;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
  }

  .form-field-container {
    display: flex;
    flex-direction: column;
    margin: 10px 0;
  }

  .created-by {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
  }

  .created-by-main {
    margin: 0;
    padding: 0;
    font-size: 18px;
  }

  input {
    border: 2px solid #ddd;
    border-radius: 3px;
    padding: 10px;
    width: 100%;
    font-size: 16px;
    margin: 10px 0;
  }

  select {
    border: 2px solid #ddd;
    border-radius: 3px;
    padding: 10px;
    width: 100%;
    font-size: 16px;
    margin: 10px 0;
  }

  textarea {
    border: 2px solid #ddd;
    border-radius: 3px;
    width: 100%;
    padding: 10px;
    font-size: 16px;
    margin: 10px 0;
  }

  label {
    font-size: 18px;
    margin-bottom: 5px;
  }

  button {
    background-color: #007bff;
    border: none;
    color: white;
    padding: 10px 30px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 10px 0;
    cursor: pointer;
    border-radius: 5px;
    align-self: center;
  }

  .btn-container {
    align-self: center;
  }
`;
